import EcoEmail from 'eco-design/elements/eco-email';
import dayjs from 'dayjs';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/i18n';
import { useGlobal } from '@/utils/useGlobal';

const CONTACT_LIST_ID_MAP = {
    us: '1487185288',
};

function TheComp() {
    const { getSystemTime } = useGlobal();
    const { locale = 'us' } = getLocal();
    const { t } = useLang('theProduct');

    const systemTime = getSystemTime();
    const date = dayjs(systemTime).format('YYYY-MM-DD') as any;
    const FIELDS_MAP = {
        us: [
            {
                id: '4423',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: false,
            },
            {
                id: '9435',
                type: 'multiple',
                value: [23],
                overwrite: false,
            },
            { type: 'text', id: '9625', value: date, overwrite: false },
        ],
    };

    return (
        <section
            className={`${css.section} on-the-road-A GtmModuleData-section`}
            id="on-the-road-A"
            data-section-id={'on-the-road-A'}
            data-section-title={t('A_title')}
        >
            <div className="A-img">
                <picture className="picture">
                    <source
                        media={`(min-width: 1025px)`}
                        srcSet="https://websiteoss.ecoflow.com/figma-uploads/1767839116612-nrjx5a-compressed-Frame%2027.webp"
                        type="image/webp"
                    />
                    <source
                        media={`(min-width: 1025px)`}
                        srcSet="https://websiteoss.ecoflow.com/figma-uploads/1767839103309-sf9bew-compressed-Frame%2027.jpg"
                        type="image/jpg"
                    />
                    <source
                        media={`(max-width: 1024px)`}
                        srcSet="https://websiteoss.ecoflow.com/figma-uploads/1767839143100-4dn5vf-compressed-home-carousel-banner.webp"
                        type="image/webp"
                    />
                    <source
                        media={`(max-width: 1024px)`}
                        srcSet="https://websiteoss.ecoflow.com/figma-uploads/1767839147392-y0rs1h-compressed-home-carousel-banner.jpg"
                    />
                    <img
                        fetchpriority="high"
                        loading="eager"
                        src="https://websiteoss.ecoflow.com/figma-uploads/1767839147392-y0rs1h-compressed-home-carousel-banner.jpg"
                        alt={t('A_title')}
                        width="100%"
                        height="100%"
                    />
                </picture>
            </div>

            <div className="A-info">
                <div className="A-title">{t('A_title')}</div>
                <div className="A-desc">{t('A_desc')}</div>
                <EcoEmail
                    contactListId={[CONTACT_LIST_ID_MAP[locale as 'us']]}
                    fields={FIELDS_MAP[locale as 'us']}
                    defaultTermsCheck
                    tipsObj={{
                        placeholder: t('A_email_placeholder'),
                    }}
                    termsHtml={`* I agree to EcoFlow's <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and <a href="https://us.ecoflow.com/pages/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Service</a>.`}
                />
            </div>
        </section>
    );
}

export default TheComp;
